import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getUserDetails } from "services/AuthService";
import {  updateProfile } from "services/UserService";

const ProfileForm = () => {
  const [formData, setFormData] = useState({
    emp_code: "",
    first_name: "",
    phone: "",
    email: "",
    password: "",
    hint: ""   
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);  
  const [successMsg, setSuccessMsg] = useState(null);  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }; 

  useEffect(() => {
   
   const user = getUserDetails();
   const { password, ...rest } = user;
   setFormData({ ...rest, password: ""});
   
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newErrors = validate();
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({});
        setLoading(true);
        const payload = {
          ...formData
        };
        let response= await updateProfile(payload);
        
        setLoading(false);
        if (response?.data?.success) {
          setSuccessMsg(response?.data?.message)
        } else if (response?.data?.errors) {
        
          const serverErrors = {};
          for (const field in response.data.errors) {
            serverErrors[field] = response.data.errors[field][0]; 
          }
          setErrors(serverErrors);
        }
      }
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.first_name) {
      newErrors.first_name = "Name is required";
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
    }
    
    return newErrors;
  };

  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-users"></i>
        </div>
        <div className="header-title">
          <h1>Profile</h1>
          <small>Hotel Manage admin Panel.</small>
        </div>
      </section>

      <section className="content">
        <div className="row">

          <div className="col-sm-12">
            <div className="card lobicard all_btn_card">
             
              <div className="card-body">
              <p style={{color:'green'}}>{successMsg}</p>
                <form className="col-sm-12" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Employee Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="emp_code"
                      placeholder="Enter Employee Code"
                      value={formData.emp_code}
                      onChange={handleChange}
                      required
                    />
                     {errors.emp_code && (
                      <small className="text-danger">{errors.emp_code}</small>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Employee Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="first_name"
                      placeholder="Enter Employee Name"
                      value={formData.first_name}
                      onChange={handleChange}
                      required
                    />
                    {errors.first_name && (
                      <small className="text-danger">{errors.first_name}</small>
                    )}
                    
                  </div>

                  <div className="form-group">
                    <label>Employee Phone No.</label>
                    <input
                      type="number"
                      className="form-control"
                      name="phone"
                      placeholder="Enter Employee Phone No."
                      value={formData.phone}
                      readOnly                      
                    />
                     {errors.phone && (
                      <small className="text-danger">{errors.phone}</small>
                    )}
                    
                  </div>

                  <div className="form-group">
                    <label>Login User Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      placeholder="Enter Login User Name"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Login Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      placeholder="Enter Login Password"
                      value={formData.password}
                      onChange={handleChange}
                      
                    />
                    {errors.password && (
                      <small className="text-danger">{errors.password}</small>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Enter Hint</label>
                    <input
                      type="password"
                      className="form-control"
                      name="hint"
                      placeholder="Enter hint"
                      value={formData.hint}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  

                  <div className="reset-button">
                    <button type="submit" className="btn btn-success" disabled={loading}>
                      {loading ? "Updating..." : "Update"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProfileForm;
